import React from 'react';
import { Provider } from 'react-redux';

import AppNavigator from './navigation/AppNavigator';
import InitialLoader from './containers/InitialLoader';
import store from './store';

import styles from './styles';
import 'antd/dist/antd.css';
import './styles/antd.css';

const isProd = process.env.NODE_ENV === 'production';

const App = () => {
  if (isProd) {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      const tokenObj = window.location.search.match(/token=(.*)/);
      if (tokenObj) {
        const [, authToken] = tokenObj;
        sessionStorage.setItem('authToken', authToken);
      }
    }
  }

  return (
    <div style={styles.container}>
      <Provider store={store}>
        <InitialLoader>
          <AppNavigator />
        </InitialLoader>
      </Provider>
    </div>
  );
};

export default App;
